module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Blender-781abb1805cc3608155cf56ff7b6629a.svg";